// import { createApp } from 'vue';
// import { createPinia } from 'pinia';

import { createApp, pinia } from './vue';

import mobileNav from './vue/apps/mobile-nav';
import desktopNav from './vue/apps/desktop-nav';

//const pinia = createPinia();

const mobileNavMountingContainer = document.getElementById('mobile-nav');
const desktopNavMountingContainer = document.getElementById('desktop-nav');

if (mobileNavMountingContainer) {
    createApp(mobileNav).use(pinia).mount(mobileNavMountingContainer);
}

if (desktopNavMountingContainer) {
    createApp(desktopNav).use(pinia).mount(desktopNavMountingContainer);
}
